<template>
  <div>
    <div class="mt-4 mx-4">
      <v-row>
        <v-col cols="6">
          <v-alert
            color="cyan"
            border="left"
            elevation="2"
            colored-border
            icon="mdi-clock"
          >
            Total Hours <strong>{{ getCurrency }} {{ this.totalHours }}</strong>
          </v-alert>
        </v-col>
        <v-col cols="6">
          <v-alert
            color="cyan"
            border="left"
            elevation="2"
            colored-border
            icon="mdi-cash-multiple"
          >
            Total Payout
            <strong>{{ getCurrency }} {{ this.totalPayout }}</strong>
          </v-alert>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="appointmentsCurrentMonth"
        :items-per-page="5"
        class="elevation-1"
      ></v-data-table>
    </div>
  </div>
</template>

<script>
import eventsJs from "@/plugins/events";
import { mapGetters } from "vuex";
export default {
  computed: mapGetters(["getUserCompany", "getCurrency"]),
  props: {
    staff: {
      default: null,
    },
  },
  data: () => ({
    appointmentsCurrentMonth: [],
    totalPayout: 0,
    totalHours: 0,
    status: "Yes",
    headers: [
      { text: "Title", value: "title" },
      { text: "Start", value: "start" },
      { text: "End", value: "end" },
      { text: "Rates", value: "rates" },
      { text: "Hours", value: "hours" },
      { text: "Line Total", value: "lineTotal" },
    ],
  }),
  async mounted() {
    this.$store.commit("setLoader", true);
    await this.getAllAppointmentsByStaffCurrentMonth();
    this.$store.commit("setLoader", false);
  },
  methods: {
    async getAllAppointmentsByStaffCurrentMonth() {
      this.appointmentsCurrentMonth =
        await eventsJs.getAllAppointmentsByStaffCurrentMonth(
          this.getUserCompany.emis,
          this.status,
          this.staff.id
        );
      this.calculateTotalPayouts(this.appointmentsCurrentMonth);
    },
    calculateTotalPayouts(appointmentsCurrentMonth) {
      if (appointmentsCurrentMonth.length > 0) {
        this.totalPayout = 0;
        this.totalHours = 0;
        appointmentsCurrentMonth.forEach((appointment) => {
          const lineTotal = (
            Number(appointment.rates) * Number(appointment.hours)
          ).toFixed(2);
          appointment["lineTotal"] = Number(lineTotal);
          this.totalPayout += Number(lineTotal);
          this.totalHours += Number(appointment.hours);
        });
      }
    },
  },
};
</script>
